import { ResolutionModel } from '@aipb/gulliver/dropbox/model';

import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TranslocoModule } from '@jsverse/transloco';
import { NgFormsManager } from '@ngneat/forms-manager';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

const FORM_NAME = 'download_form';

@Component({
  selector: 'cat-download-form',
  templateUrl: './download-form.component.html',
  styleUrls: ['./download-form.component.scss'],
  standalone: true,
  imports: [
    MatFormFieldModule,
    ReactiveFormsModule,
    TranslocoModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule
  ]
})
export class DownloadFormComponent implements OnInit, OnDestroy {
  @Input() countChecked: number;
  @Input() disabled: boolean;
  @Output() download = new EventEmitter<[ResolutionModel, string]>();
  downloadForm: UntypedFormGroup;

  private fb = inject(UntypedFormBuilder);
  private formsManager = inject(NgFormsManager);

  private _resolutions: ResolutionModel[] = [];

  get resolutions(): ResolutionModel[] {
    return this._resolutions;
  }

  @Input() set resolutions(value: ResolutionModel[]) {
    this._resolutions = value;

    const resolutionControl = this.formsManager.getControl(FORM_NAME, 'resolution');

    if (resolutionControl && !resolutionControl?.value && this._resolutions.length > 0) {
      this.formsManager.patchValue(FORM_NAME, {
        resolution: this._resolutions[0]
      });
    }
  }

  ngOnInit(): void {
    this.downloadForm = this.fb.group({
      resolution: [null, Validators.required],
      zip_name: [Date.now(), Validators.required]
    });

    this.formsManager.upsert(FORM_NAME, this.downloadForm, {
      persistState: true
    });
  }

  ngOnDestroy() {
    this.formsManager.unsubscribe(FORM_NAME);
  }

  onDownload(): void {
    if (!this.downloadForm.valid) return;

    const resolution: ResolutionModel = this.downloadForm.value.resolution;
    this.download.emit([resolution, this.downloadForm.value.zip_name + '']);
  }

  compareResolutions(a: ResolutionModel, b: ResolutionModel): boolean {
    return a && b ? a.id === b.id : a === b;
  }
}
